export default "__VITE_ASSET__1f4c4f2e__"